/** @prettier */

/**
 * SL通信設定の室外機一覧
 */

import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Snackbar,
  Drawer,
  Button,
  Grid,
} from '@mui/material';
import IconButton from '@mui/material/IconButton';
import {useState} from 'react';
import {useTranslation} from 'react-i18next';
import {useParams} from 'react-router-dom';
//API import
import {
  getCompositionsSitesBySiteID,
  postCommandsGateway,
} from '../../API/API_Collection';
//interface import
import * as apiIF from '../../Type/api';
//Style import
import '../../css/common/common.css';
import {iconBlack} from '../../define';

import {utcToZonedTime, zonedTimeToUtc} from 'date-fns-tz';
import {format} from 'date-fns';
import UpgradeIcon from '@mui/icons-material/UpgradeRounded';
import {PrimaryButton, SecondaryButton} from '../../component/BasicButton';
import {State} from '../gw-registration/GWSetting';

const GWConfigUpdateDrawer = (props: {
  hasConfigGW: boolean;
  setHasConfigGW: (arg0: boolean) => void;
  hasUnit: boolean;
}) => {
  const {siteID, gwID} = useParams();
  const trans = useTranslation().t; //翻訳関数
  const [isOpenConfigDialog, setIsOpenConfigDialog] = useState(false); //設定反映ダイアログ表示フラグ
  const [clickButton, setClickButton] = useState(false); //ダイアログのOKがClickされたらTrue

  const [state, setState] = useState<State>({
    open: false,
    vertical: 'top',
    horizontal: 'center',
  });
  const {vertical, horizontal, open} = state;

  /**
   * 構成情報更新ボタン押下時処理
   */
  const applyExecConfig = () => {
    //パスパラメータを取得できない場合
    if (siteID === undefined) return;
    setClickButton(true);
    //サイトの情報を取得
    getCompositionsSitesBySiteID(siteID)
      .then(response => {
        const dateNow = new Date();
        const now = format(
          utcToZonedTime(dateNow, response['timezone']),
          'yyyy-MM-dd HH:mm:ss'
        );
        const date = zonedTimeToUtc(now, response['timezone']).toISOString();
        const body: apiIF.reqParameters.postCommandsGateway = {
          date: date,
          mode: 'configuration-update',
        };
        //構成情報のアップデートを開始
        if (siteID === undefined || gwID === undefined) return;
        return postCommandsGateway(siteID, gwID, body);
      })
      .then(() => {
        //反映完了後、Configボタンを非表示とする。
        props.setHasConfigGW(false);
        setState({open: true, vertical: 'top', horizontal: 'center'});
      })
      .catch(err => {
        alert(trans('GWConfigUpdateDrawer.executionResult.error'));
      })
      .finally(() => {
        setIsOpenConfigDialog(false);
        setClickButton(false);
      });
  };
  /**
   * ゲートウェイ再起動のスナックバー表示処理
   */
  const handleClose = () => {
    setState({...state, open: false});
  };

  return (
    <>
      {/* Config Updateボタン */}
      <Drawer
        anchor={'bottom'}
        variant="persistent"
        open={props.hasConfigGW && props.hasUnit}
        onClose={() => props.setHasConfigGW(false)}>
        <Grid
          container
          justifyContent={'center'}
          className="gwSetting__configUpdateDrawer">
          <Grid container item xs={8}>
            <Grid item xs={12} className="gwSetting__configUpdateDrawer__title">
              {trans('GWConfigUpdateDrawer.message.title')}
            </Grid>
            <IconButton
              onClick={() => props.setHasConfigGW(false)}
              className={'gwSetting__configUpdateDrawer__IconButton'}>
              <img
                src={iconBlack.CLOSE.src}
                alt={`${trans(
                  `GWConfigUpdateDrawer.message.${iconBlack.CLOSE.alt}`
                )}`}
              />
            </IconButton>
            <Grid item xs={12} className="gwSetting__configUpdateDrawer__text">
              {trans('GWConfigUpdateDrawer.message.text')}
            </Grid>
            <Grid
              item
              xs={12}
              justifyContent={'flex-end'}
              className="gwSetting__configUpdateDrawer__buttonBox">
              <Button
                onClick={() => setIsOpenConfigDialog(true)}
                variant="outlined"
                className={'gwSetting__configUpdateDrawer__buttonBox__button'}
                startIcon={<UpgradeIcon />}>
                {trans('GWConfigUpdateDrawer.buttonText')}
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Drawer>
      {/* 構成情報反映ダイアログ */}
      <Dialog
        open={isOpenConfigDialog}
        onClose={() => setIsOpenConfigDialog(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        id={'RebootDialog'}>
        <DialogTitle id="alert-dialog-title">
          {trans('GWConfigUpdateDrawer.dialog.title')}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {trans('GWConfigUpdateDrawer.dialog.text')}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <SecondaryButton
            onClick={() => setIsOpenConfigDialog(false)}
            buttonText={trans('GWConfigUpdateDrawer.dialogAction.cancel')}
            id={'RebootDialogBtnCancel'}
          />
          {/* API完了後、画面遷移 */}
          <PrimaryButton
            onClick={() => applyExecConfig()}
            buttonText={trans('GWConfigUpdateDrawer.dialogAction.ok')}
            className="btnOK"
            id={'RebootDialogBtnOK'}
            disabled={clickButton}
            apiWait={clickButton}
          />
        </DialogActions>
      </Dialog>
      {/* 構成情報アップデート時のメッセージ */}
      <Snackbar
        anchorOrigin={{vertical, horizontal}}
        open={open}
        onClose={handleClose}
        message={`${trans('GWConfigUpdateDrawer.executionResult.reboot')}`}
        key={vertical + horizontal}
      />
    </>
  );
};
export default GWConfigUpdateDrawer;
